import React from 'react';

const CrossCircle = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.3438 16.1133L3.88672 5.65625C3.01172 6.87891 2.5 8.37891 2.5 10C2.5 14.1406 5.85938 17.5 10 17.5C11.6211 17.5 13.1211 16.9883 14.3438 16.1133ZM16.1133 14.3438C16.9883 13.1211 17.5 11.6211 17.5 10C17.5 5.85938 14.1406 2.5 10 2.5C8.37891 2.5 6.87891 3.01172 5.65625 3.88672L16.1133 14.3438ZM0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10Z",
      fill: "#FF0000"
    }
  )
);
CrossCircle.displayName = "Icons.CrossCircle";

export { CrossCircle };
//# sourceMappingURL=CrossCircle.js.map
